function Notice(scope) {
    var notice = scope.find('#notice');
    if(notice.length > 0) {
        setTimeout(function() {
            notice.collapse('hide');
        }, 5000)
    }
}

export default Notice;